import { BasePage as CngBasePage } from 'cng-web-lib'
import React from 'react'
import ArchivedDataUploadPage from './ArchivedDataUploadPage.js'
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap'

function WrappedArchivedDataUploadPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <ArchivedDataUploadPage showNotification={showSnackbar} {...props} />
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

export {
  WrappedArchivedDataUploadPage as ArchivedDataUploadPage
}
